import GameConfigContent from '../../component/GameConfig/GameConfigContent';

const GameConfigContainer = () => {
  return <GameConfigContent />;
};

export default GameConfigContainer;
